'use client';
import { useEffect, useState, useRef } from 'react';

const useScrollShadow = () => {
	const [isScrolledLeft, setIsScrolledLeft] = useState(true);
	const [isScrolledRight, setIsScrolledRight] = useState(false);
	const scrollRef = useRef<HTMLDivElement>(null);

	useEffect(() => {
		const scrollElement = scrollRef.current;
		const updateScrollShadows = () => {
			if (!scrollElement) return;

			const isAtStart = scrollElement.scrollLeft === 0;
			const isAtEnd =
				Math.ceil(scrollElement.scrollLeft + scrollElement.clientWidth) >=
				scrollElement.scrollWidth;

			setIsScrolledLeft(isAtStart);
			setIsScrolledRight(isAtEnd);
		};

		scrollElement?.addEventListener('scroll', updateScrollShadows);
		updateScrollShadows();

		return () => scrollElement?.removeEventListener('scroll', updateScrollShadows);
	}, []);

	return { scrollRef, isScrolledLeft, isScrolledRight };
};

export default useScrollShadow;
